import { Component, EventEmitter, Output, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AgendaModelV3, AgendaEvent, QueovalDateTime, SelectedEvent, AgendaRow, AgendaCol, Calendar } from '../../../models';
import { QueovalDateService, CoreService, HttpService } from '../../../services';
import { ToastService } from '../../../toast';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-affiche-planning-v3',
  templateUrl: './affiche.planning.component.html',
  styleUrls: ['./affiche.planning.component.css', '../affiche.component.css']
})
// Affiche la grille du calendrier
export class AffichePlanningComponentV3 {
  public boolDataNeedToBeUpdated: boolean;
  public dragStart: boolean = false;
  public dragColId: number;
  public calendarIndex: number;
  public contextEvent: AgendaEvent | null;

  private elementDragged: AgendaEvent = new AgendaEvent();
  private isUpdate: boolean = false;

  public startIndex: number = 0;

  @Input() LoadInfos: boolean;
  @Input() enlargeContainer: boolean;

  @Input() model: AgendaModelV3;
  @Output('modelChange') modelChange: EventEmitter<AgendaModelV3> = new EventEmitter<AgendaModelV3>(true);

  @Output('openEvent') openEvent: EventEmitter<AgendaEvent> = new EventEmitter<AgendaEvent>(true);
  @Output('newEvent') newEvent: EventEmitter<{ date: QueovalDateTime, iCalendar: number }> = new EventEmitter<{ date: QueovalDateTime, iCalendar: number }>(true);
  @Output('updateEvent') updateEvent: EventEmitter<AgendaEvent> = new EventEmitter<AgendaEvent>(true);
  @Output('loading') loading: EventEmitter<boolean> = new EventEmitter<boolean>(true);


  @ViewChild('grid') grid: ElementRef;
  @ViewChild('gridHeader') gridHeader: ElementRef;
  @ViewChild('gridBody') gridBody: ElementRef;
  constructor(
    private http: HttpService,
    private httpClient: HttpClient,
    protected toastService: ToastService,
    public indParam: CoreService,
    protected qdate: QueovalDateService,
    public changeDetectorRef: ChangeDetectorRef
  ) { }

  public CalculatedIndex(iWeek: number, i: number): number {
    let sumPastWeek = 0;
    if (iWeek > 0) {
      sumPastWeek = (this.model.listCalendars[0].body.weeklyRows[0].cols.length + (7 - this.model.dayByWeek)) + ((iWeek - 1) * 7)
    }
    return sumPastWeek + i;
  }
  public CompareDates(i: number): boolean {
    return this.qdate.Compare(this.qdate.Now(), '=', this.model.listCalendars[0].body.startDate, i, 'days');
  }

  public EmitEvent(event: AgendaEvent): void {
    this.isUpdate = true;
    if (!event.isAnonimized && (event.isReadable || event.isUpdatable)) {
      this.openEvent.emit(event);
    }
    setTimeout(() => {
      this.isUpdate = false;
    }, 500);
  }

  public OpenModal(daysToAdd: number, index: number): void {
    setTimeout(() => {
      if (!this.isUpdate) {
        const date: Date = this.qdate.ToDate(this.model.listCalendars[index].body.startDate) as Date;
        if (this.model.dayByWeek === 1) {
          date.setHours(daysToAdd, 0, 0);
        } else {
          date.setDate(date.getDate() + daysToAdd);
        }
        this.newEvent.emit({ date: this.qdate.FromDateTime(date), iCalendar: index });
      }
    }, 0)
  }

  //#region drag & drop
  public allowDrop(ev: any, icol: number, index: number): void {
    if ((this.elementDragged.pere === this.model.listCalendars[index].calendarOwnerId && !this.elementDragged.GroupMode)
      || (this.elementDragged.pere === this.model.listCalendars[index].calendarOBjectId && this.elementDragged.code_DOR === 'REL_BO_OBJET_BO_RESERV')
      || (this.elementDragged.pere === this.model.listCalendars[index].calendarOfficeId && this.elementDragged.code_DOR === 'REL_BO_BUREAU_BO_RESERV')
      || (this.elementDragged.pere === this.model.listCalendars[index].calendarGroupId && !!this.elementDragged.GroupMode)) {
      this.dragColId = icol;
      this.calendarIndex = index;
      ev.preventDefault();
    }
  }
  public DisableDrop(ev: any): void {
    ev.stopPropagation();
  }

  public DragEnd(): void {
    this.dragStart = false;
  }

  public dragEvent(event: AgendaEvent): void {
    this.dragStart = true;
    this.elementDragged = event;
  }
  public onDrop(e: any, dayIndex: number, index: number): void {
    if (this.elementDragged.pere !== this.model.listCalendars[index].calendarOwnerId
      && !(this.elementDragged.pere === this.model.listCalendars[index].calendarOBjectId && this.elementDragged.code_DOR === 'REL_BO_OBJET_BO_RESERV')
      && !(this.elementDragged.pere === this.model.listCalendars[index].calendarOfficeId && this.elementDragged.code_DOR === 'REL_BO_BUREAU_BO_RESERV')
      && !(this.elementDragged.pere === this.model.listCalendars[index].calendarGroupId && !!this.elementDragged.GroupMode)) {
      if (this.elementDragged.code_DOR === 'REL_BO_OBJET_BO_RESERV') this.toastService.showAlertToast(`impossible de transférer les événements d'un objet à un autre`);
      else if (this.elementDragged.code_DOR === 'REL_BO_BUREAU_BO_RESERV') this.toastService.showAlertToast(`impossible de transférer les événements d'un bureau à un autre`);
      else if (!!this.elementDragged.GroupMode)
      {
        switch (this.elementDragged.GroupMode) {
          case 'CLIENT':
            this.toastService.showAlertToast(`impossible de transférer les événements d'un client à un autre`);
            break;
          case 'STAGIAIRE':
            this.toastService.showAlertToast(`impossible de transférer les événements d'un stagiaire à un autre`);
            break;
          case 'FORMATEUR':
            this.toastService.showAlertToast(`impossible de transférer les événements d'un formateur à un autre`);
            break;
          case 'FORMATION':
            this.toastService.showAlertToast(`impossible de transférer les événements d'une formation à un autre`);
            break;
        }
      }
      else this.toastService.showAlertToast(`impossible de transférer les événements d'un collaborateur à un autre`);
    }
    else {
      //#region construction du model
      const model: AgendaModelV3 = JSON.parse(JSON.stringify(this.model));
      model.Mode = 'UPDATE_DATE';
      model.selectedEvent = new SelectedEvent();
      model.selectedEvent.pEvent = this.elementDragged;
      let startDate: Date | null = this.qdate.ToDate(this.model.listCalendars[index].body.startDate);
      if (startDate) {
        if (this.model.dayByWeek === 1) {
          startDate.setHours(dayIndex);
        } else {
          startDate.setDate(startDate.getDate() + dayIndex);
        }

      }

      model.selectedEvent.pEvent.startDate = this.qdate.FromDateTime(startDate);
      if (this.model.dayByWeek !== 1) {
        model.selectedEvent.pEvent.startDate.heures = '';
      }
      model.selectedEvent.pEvent.startDate.minutes = '';
      model.selectedOwnerIndex = index;

      //#endregion
      if (this.elementDragged.isUpdatable) {
        this.loading.emit(true);
        this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/`, model).subscribe(
          (result: AgendaModelV3) => {
            this.loading.emit(false);
            if (result.Mode) {
              this.model = result;
            }
            this.modelChange.emit(this.model);
          })
      } else {
        this.toastService.showAlertToast('vous ne disposez pas des droits nécessaires');
      }
    }
  }

  public SetPosition(): void {
    window.requestAnimationFrame(() => {
      let scrollLeft = $(this.gridBody.nativeElement).scrollLeft() as number;

      // Keep in place the locked cells
      $(this.grid.nativeElement).find('.locked-col').css('transform', 'translate3D(' + scrollLeft + 'px, 0, 0)');

      // Synchronize Header and Footer scrolling
      $(this.gridHeader.nativeElement).scrollLeft(scrollLeft);
    })
  }
  // #endregion

  public ExportToXls(): void {
    this.indParam.showSplash(true);
    const clt: string = this.indParam.AppParams.culture ? this.indParam.AppParams.culture : '';
    const gmt: string = this.indParam.AppParams.GMT ? this.indParam.AppParams.GMT : '';
    const tkn: string = this.indParam.AppParams.token ? this.indParam.AppParams.token : '';
    const headers = new HttpHeaders()
      .set('Access-Control-Allow-Origin', '*')
      .set('Access-Control-Allow-Methods', 'GET, POST, PUT, DELETE, OPTIONS')
      .set('Access-Control-Allow-Headers', 'Content-Type, Authorization, Origin, Accept, X-Requested-With, Access-Control-Request-Method, Access-Control-Request-Headers')
      .set('Accept-Language', clt)
      .set('Content-Type', 'application/json')
      .set('Qgmt', gmt)
      .set('Queoval', tkn)

    this.httpClient.post(`${this.indParam.AppParams.apiUrl}api/agenda/v3/export/excel`, this.model, { headers: headers, responseType: 'text' }).subscribe(
      (result: any) => {
        if (result) {
          var myBlob = new Blob(['\ufeff', result], { type: 'text/html' });
          var url = window.URL.createObjectURL(myBlob);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = `planning Semaine${this.model.listCalendars[0].body.WeekNumbers.length > 1 ? 's' : ''} ${this.model.listCalendars[0].body.WeekNumbers[0]} ${this.model.listCalendars[0].body.WeekNumbers.length > 1 ? '- ' + (this.model.listCalendars[0].body.WeekNumbers[this.model.listCalendars[0].body.WeekNumbers.length - 1]) : ''}.xls`;
          a.click();
          //adding some delay in removing the dynamically created link solved the problem in FireFox
          this.indParam.showSplash(false);
          setTimeout(function () {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }, 250);
        }
      });
  }

  public trackWeeklyRows(index: number, item: AgendaRow) {
    return item.id;
  }
  public trackWeeklyCols(index: number, item: AgendaCol) {
    return item.id;
  }
  public trackWeeklyEvents(index: number, item: AgendaEvent) {
    return item.ident;
  }
  public trackCalendar(index: number, item: Calendar) {
    return item.calendarOwnerId;
  }
  public BufferAmount(scroll: VirtualScrollerComponent): number {
    if (scroll && scroll.viewPortItems) return 4 - scroll.viewPortItems.length < 2 ? 2 : 4 - scroll.viewPortItems.length;
    else return 1;
  }
  public VirtualScrollIndex(firstCalendar: Calendar, index: number): number {
    return this.model.listCalendars.findIndex(c => c === firstCalendar) + index;
  }
}
